export default "__VITE_ASSET__DFeb1MTK__"